import {fork} from 'redux-saga/effects';
import {combineReducers} from 'redux';

import {sagas as dealSagas, reducer as dealR} from './deal';
// import {sagas as homeSagas} from './home';
import {sagas as interestSagas} from './interest';
import {sagas as investSagas} from './invest';
import {sagas as leadSagas} from './lead';
import {sagas as routingSagas} from './routing';
import {sagas as sessionSagas} from './session';
import {sagas as docsSagas} from './docs';
import {sagas as accountSagas} from './account';

import {reducer as interestR} from './interest/reducer';
import {reducer as leadR} from './lead/reducer';

export function* sagas() {
  yield fork(dealSagas);
  // yield fork(homeSagas);
  yield fork(interestSagas);
  yield fork(investSagas);
  yield fork(leadSagas);
  yield fork(routingSagas);
  yield fork(sessionSagas);
  yield fork(docsSagas);
  yield fork(accountSagas);
}

export const reducer = combineReducers({
  interest: interestR,
  lead: leadR,
  deal: dealR,
});



// WEBPACK FOOTER //
// ./mobile/shared/flows/index.js